import { useState } from "react";
import { Button, Field, Input } from "../../shared/ui/index.js";
import { Sheet } from "./Sheet.js";
import type { GuestIdentity } from "./guest.api.js";

const isEmail = (v: string) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v.trim());

export function IdentitySheet({
  open,
  initial,
  dismissible,
  onSave,
  onClose,
}: {
  open: boolean;
  initial: GuestIdentity;
  dismissible: boolean;
  onSave: (id: GuestIdentity) => void;
  onClose: () => void;
}) {
  const [name, setName] = useState(initial.name);
  const [email, setEmail] = useState(initial.email);
  const valid = name.trim().length > 0 && isEmail(email);

  return (
    <Sheet open={open} onClose={dismissible ? onClose : undefined} title="Présentez-vous">
      <p className="mb-4 text-center text-sm text-stone-500">
        Le même nom et email vous permettent de retrouver vos envois, même depuis un autre
        téléphone.
      </p>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (valid) onSave({ name: name.trim(), email: email.trim().toLowerCase() });
        }}
        className="flex flex-col gap-3"
      >
        <Field label="Votre nom">
          <Input
            autoFocus
            autoComplete="name"
            placeholder="Marie Dupont"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Field>
        <Field label="Votre adresse email">
          <Input
            type="email"
            inputMode="email"
            autoComplete="email"
            placeholder="vous@exemple.fr"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Field>
        <Button type="submit" disabled={!valid} className="mt-1">
          Continuer
        </Button>
      </form>
    </Sheet>
  );
}
